import React, { FC } from "react";

import { makeStyles } from "@fluentui/react-components";

import Navbar from "../../layout/Navbar";

export const Page: FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.pageContainer}>
      <Navbar />
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>{children}</div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  contentContainer: {
    display: "flex",
    flex: "1 1 0%",
    flexDirection: "column",
    height: "100%",
    justifyContent: "flex-start",
    overflow: "hidden",
    paddingBottom: "8px",
    width: "100%",
  },
  contentWrapper: {
    display: "flex",
    flex: "1 1 0%",
    flexDirection: "column",
    flexGrow: "1",
    overflow: "hidden",
    position: "relative",
  },
  pageContainer: {
    background: "#F3F4F6",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
});
